import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getGlobalItemsGroup, getMyGlobalItemsGroup } from 'store/myItems/store/selectors';
import GlobalSearchSuccessResults from 'components/organisms/GlobalSearchSuccessResults/GlobalSearchSuccessResults';
import Alooma from 'services/alooma';
import * as ALOOMA from 'consts/alooma';
import { getQueryParam } from 'functions/urlHelpers';
import { QUERY_PARAMS } from 'consts/queryParams';

const GlobalSearchSuccessResultsContainer = ({ retailers }) => {
  const query = getQueryParam(QUERY_PARAMS.query);
  const globalItemsGroup = useSelector(getGlobalItemsGroup);
  const myGlobalItemsGroup = useSelector(getMyGlobalItemsGroup);
  const successNonContextDataAttrs = useMemo(
    () => ({
      [ALOOMA.PARAMS.SEARCH_PHRASE]: query,
      [ALOOMA.PARAMS.SEARCH_RESULTS]: {
        [ALOOMA.SECTIONS.STORES]: retailers?.map(retailer => retailer.self_id),
        [ALOOMA.SECTIONS.SAVED_ITEMS]: myGlobalItemsGroup?.tags?.map(tag => tag.id),
        [ALOOMA.SECTIONS.OTHER_ITEMS]: globalItemsGroup?.tags?.map(tag => tag.id),
      },
    }),
    [],
  );

  return (
    <Alooma.NonStandardDataContext.Provider value={successNonContextDataAttrs}>
      <GlobalSearchSuccessResults retailers={retailers} />
    </Alooma.NonStandardDataContext.Provider>
  );
};

export default GlobalSearchSuccessResultsContainer;
